import { useState } from "react";
import { Plus, Loader2, Trash2 } from "lucide-react";
import { inputCls } from "@/lib/appsApi";

const pill = (on) => `rounded-full border px-4 py-2 text-sm font-medium transition-colors ${on ? "border-ink bg-ink text-white" : "border-slate-200 bg-white text-slate-700 hover:border-sky-600 hover:text-sky-700"}`;

export const AppPills = ({ apps, active, onSelect }) => (
  <div className="flex flex-wrap gap-2" data-testid="bundle-app-pills">
    {apps.map((a) => (
      <button key={a.id} type="button" onClick={() => onSelect(a.id)} className={pill(a.id === active)} data-testid={`bundle-app-${a.id}`}>
        {a.name}<span className="ml-2 font-mono text-xs opacity-80">{a.units.length}</span>
      </button>
    ))}
  </div>
);

// Small one-field (plus optional select) add form, used for both new apps and new units.
export const AddForm = ({ placeholder, button, onAdd, testid, children }) => {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    const ok = await onAdd(name.trim());
    setBusy(false);
    if (ok) setName("");
  };
  return (
    <form onSubmit={submit} className="flex flex-col gap-2 sm:flex-row" data-testid={testid}>
      <input value={name} onChange={(e) => setName(e.target.value)} maxLength={60} placeholder={placeholder} className={`${inputCls} sm:flex-1`} data-testid={`${testid}-input`} />
      {children}
      <button type="submit" disabled={busy || !name.trim()} className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-sky-700 disabled:opacity-50" data-testid={`${testid}-submit`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />}{button}
      </button>
    </form>
  );
};

export const AppSettings = ({ app, tabs, onSave, onDelete }) => {
  const [confirm, setConfirm] = useState(false);
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm text-slate-700" data-testid="bundle-app-settings">
      <label className="flex items-center gap-2">
        <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">Hand downloads for testers in</span>
        <select value={app.tab_id} onChange={(e) => onSave({ name: app.name, tab_id: e.target.value })} className="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-sm text-ink focus:border-sky-600 focus:outline-none" data-testid="bundle-app-tab-select">
          {tabs.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
      </label>
      <button type="button" onClick={() => (confirm ? onDelete(app) : setConfirm(true))} onBlur={() => setConfirm(false)}
        className={`inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-xs transition-colors ${confirm ? "bg-red-600 text-white" : "text-slate-500 hover:bg-red-50 hover:text-red-600"}`} data-testid="bundle-app-delete">
        <Trash2 className="h-3.5 w-3.5" />{confirm ? `Remove ${app.name}?` : "Remove app"}
      </button>
    </div>
  );
};
